import { render, staticRenderFns } from "./drawers.global.vue?vue&type=template&id=7468549a&"
import script from "./drawers.global.vue?vue&type=script&lang=js&"
export * from "./drawers.global.vue?vue&type=script&lang=js&"
import style0 from "./drawers.global.vue?vue&type=style&index=0&id=7468549a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports